import { FeatureFlags } from '../../lib/util/flags/types';

export type DownBarItem = {
  id: DownBarIdType;
  label: string;
  path: string;
  img: JSX.Element;
  activeImg: JSX.Element;
  /** When set, the item is only rendered while that flag is enabled. */
  featureFlag?: FeatureFlags;
  /** When set, the item is only rendered while that flag is disabled. */
  hiddenByFeatureFlag?: FeatureFlags;
};

export enum DownBarIdType {
  Watchlist = 'watchlistMenuItem',
  Discover = 'discoverMenuItem',
  Payouts = 'payoutsMenuItem',
  Referrals = 'referralsMenuItem',
  MyAccount = 'myAccountMenuItem',
  Funds = 'fundsMenuItem',
  MyProfile = 'myProfile',
  History = 'historyMenuItem',
  Reports = 'reports',
  HelpCenter = 'helpCenterMenuItem',
  Dashboard = 'dashboard',
}
